export default {
  namespaced: true,
  state: {
    globalDomainInfo: {
      name: "爱易佰",
      domainName: "pingcexue.com",
      domainLogo: "/static/aie-logo.jpg",
      domainCopyright:
        "Copyright © 2021 成都爱易佰网络科技有限公司 版权所有|蜀ICP备12029833号-2",
      address: "/static/favicon.ico",
      backgroundImg: "/static/BG@2x.png",
      webBoxAlign: "center",
      productCode: "CPX"
    }
  },
  getters: {
    getterGlobalDomainInfo(state) {
      return state.globalDomainInfo;
    }
  },
  mutations: {
    setGlobalDomainInfo(state, value) {
      state.globalDomainInfo = value;
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/saas/index.js